export interface Language {
  code: string;
  name: string;
  nativeName: string;
  rtl?: boolean;
  needsCJK?: boolean;
  needsArabic?: boolean;
  needsHebrew?: boolean;
}

export const LANGUAGES: Language[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski' },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska' },
  { code: 'da', name: 'Danish', nativeName: 'Dansk' },
  { code: 'no', name: 'Norwegian', nativeName: 'Norsk' },
  { code: 'fi', name: 'Finnish', nativeName: 'Suomi' },
  { code: 'cs', name: 'Czech', nativeName: 'Čeština' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська' },
  { code: 'el', name: 'Greek', nativeName: 'Ελληνικά' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', rtl: true, needsArabic: true },
  { code: 'he', name: 'Hebrew', nativeName: 'עברית', rtl: true, needsHebrew: true },
  { code: 'fa', name: 'Persian', nativeName: 'فارسی', rtl: true, needsArabic: true },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  { code: 'ms', name: 'Malay', nativeName: 'Bahasa Melayu' },
  { code: 'tl', name: 'Filipino', nativeName: 'Filipino' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', needsCJK: true },
  { code: 'ko', name: 'Korean', nativeName: '한국어', needsCJK: true },
  { code: 'zh', name: 'Chinese (Simplified)', nativeName: '简体中文', needsCJK: true },
  { code: 'zh-TW', name: 'Chinese (Traditional)', nativeName: '繁體中文', needsCJK: true },
];

export function findLanguage(code: string): Language | undefined {
  const normalized = code.toLowerCase();
  return LANGUAGES.find((l) => l.code.toLowerCase() === normalized) ??
    LANGUAGES.find((l) => l.code.toLowerCase().startsWith(normalized.split('-')[0] ?? ''));
}

export function languageName(code: string): string {
  return findLanguage(code)?.name ?? code;
}

export function languageNativeName(code: string): string {
  return findLanguage(code)?.nativeName ?? code;
}

export function detectBrowserLanguage(): string {
  if (typeof navigator === 'undefined') return 'en';
  const candidates = navigator.languages ?? [navigator.language];
  for (const c of candidates) {
    const found = findLanguage(c);
    if (found) return found.code;
  }
  return 'en';
}
